var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.viewIsEta ? 'eta-container' : '',attrs:{"id":"app"}},[_c('navbar'),_c('b-row',{staticClass:"container col-12"},[_c('side-nav'),_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }